module.exports = __webpack_public_path__ + "static/media/wind.19c57956.svg";